import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// The login GET gates every portal route but starts only once Firebase restored the session (see
// index.html): open the bppAuth connection now, alongside that restore.
const authPreconnect = document.createElement('link');
authPreconnect.rel = 'preconnect';
authPreconnect.href = environment.bppAuth;
authPreconnect.crossOrigin = '';
document.head.appendChild(authPreconnect);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
